export default "__VITE_ASSET__TVvfUXAX__"